'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // @file: Custom insert modal jsx file
// @auth: spc@data.me 2017/10/16

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('../../../../icon/text.svg');

var _text2 = _interopRequireDefault(_text);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var CustomModal = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(CustomModal, _Component);

    function CustomModal(props) {
        (0, _classCallCheck3.default)(this, CustomModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CustomModal.__proto__ || (0, _getPrototypeOf2.default)(CustomModal)).call(this, props));

        _this.onSearch = function () {
            var keyword = _this.state.keyword;

            if (keyword.length > 0) {
                _this.props.customBlockConfig.suggestCustomData(keyword).then(function (values) {
                    _this.setState({
                        data: values
                    });
                });
            }
        };

        _this.addCustom = function (data) {
            _this.props.onSubmit(data);
            _this.props.onCancel();
        };

        _this.updateKeyword = function (event) {
            _this.setState({
                keyword: event.target.value
            });
        };

        _this.handleKeyDown = function (event) {
            if (event.keyCode === 13) {
                _this.onSearch();
                event.stopPropagation();
            }
        };

        _this.state = {
            keyword: '',
            data: undefined
        };
        return _this;
    }

    (0, _createClass3.default)(CustomModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.keyRef.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var config = this.props.customBlockConfig;
            return _react2.default.createElement(
                'div',
                { className: 'rde-modal' },
                _react2.default.createElement(
                    'div',
                    { className: 'rde-modal-body' },
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-title' },
                        config.customTitle
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-input-box' },
                        _react2.default.createElement('img', { src: _text2.default, alt: '' }),
                        _react2.default.createElement('input', {
                            className: 'rde-modal-input',
                            onChange: this.updateKeyword,
                            onKeyDown: this.handleKeyDown,
                            value: this.state.keyword,
                            ref: function ref(_ref) {
                                _this2.keyRef = _ref;
                            },
                            placeholder: '\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22...'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-model-selector' },
                        this.state.data && this.state.data.map(function (value) {
                            var card = _react2.default.createElement(
                                'div',
                                { className: 'rde-model-select-item', onClick: function onClick() {
                                        return _this2.addCustom(value);
                                    }, key: value.key, role: 'presentation' },
                                config.renderCustomData(value)
                            );
                            return card;
                        }),
                        this.state.data && this.state.data.length === 0 && _react2.default.createElement(
                            'div',
                            null,
                            '\u5BF9\u4E0D\u8D77\uFF0C\u6CA1\u6709\u627E\u5230\u7ED3\u679C'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-btns' },
                        _react2.default.createElement(
                            'button',
                            { className: 'rde-modal-btn-ok', onClick: this.onSearch },
                            '\u641C\u7D22'
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'rde-modal-btn-cancel', onClick: this.props.onCancel },
                            '\u53D6\u6D88'
                        )
                    )
                )
            );
        }
    }]);
    return CustomModal;
}(_react.Component), _class.propTypes = {
    customBlockConfig: _propTypes2.default.object.isRequired,
    onSubmit: _propTypes2.default.func,
    onCancel: _propTypes2.default.func
}, _temp);
exports.default = CustomModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/components/CustomModal/index.js
// module id = 114
// module chunks = 0